module.exports = __webpack_public_path__ + "Inter-Bold.woff2?be76611f7fa8cb1ffa28ae557d0b3202";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Inter-woff2/Inter-Bold.woff2
// module id = 530
// module chunks = 309